<template lang="html">

  <section class="banner-historia column-center animation">
    <span class="background"></span>
    
    <div class="container column-start">

      <h2 class="row-start">
        <span class="s">{{$t('conoce')}}</span>
        <span class="m">{{$t('nuestra')}}</span>
        <span class="l">{{$t('historiaText')}}</span>
      </h2>
      
      <router-link :to="'/'+$i18n.locale+'/'+$t('enlaces.historia')" class="btn -action">{{$t('irAHistoria')}}</router-link>

    </div>

    <img src="/static/img/furgon-banner-historia.png" alt="furgon-banner-historia" class="furgon-banner">

  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-historia',
  }
</script>

<style scoped lang="scss">
  .banner-historia {
    width: 100%;
    height: auto;
    padding: 150px 50px;
    min-height: 90vh;
    position: relative; 
    overflow: hidden;
  }

  .background{
    background: url(/static/img/historia/fondo-0.jpg) center/cover no-repeat;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;

    &::before{
      position:absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      background: rgba(0,0,0,0.5);
      z-index: 2;
      content: '';
      display: inline-block;
    }
  }

  .container{
    position: relative;
    z-index: 5;
  }

  .furgon-banner{
    position: absolute;
    right: -30px;
    width: 70vw;
    max-width: 800px;
    z-index: 4;
    transform: translate(110%,-10%) perspective(100px) translateZ(-30px);
            transition: .8s;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.11);
    transition-delay: 1.8s;
  }

  h2{
    text-transform: uppercase;
    font-size: 100px;
    color: white;
    -ms-align-items: flex-end;
    align-items: flex-end;
    margin-bottom: 40px;
    overflow: hidden;
    max-width: 580px;
    span{ 
     font-family: 'Futura LT CondensedExtraBold';
   }

   .s{
    font-size: 50px;
    color: rgba(255,255,255,.7);
    line-height: .8em;
    margin-right: 10px;
    transform: translateX(-150%);
    transition: .5s;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
  }

  .m{
    font-size: 70px;
    color: rgba(255,255,255,.8); 
    line-height: .8em;
    transform: translateX(150%);
        transition: .5s;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
    transition-delay: .8s;
  } 

  .l{
    width: 100%;
    display: inline-block;
    font-size: 100px;
    color: white;
    text-align: left;
    line-height: .8em;
    margin-top: 10px;
    transform: translateY(150%);
        transition: .5s;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.53);
    transition-delay: 1.2s;

  }
}

.btn.-action{
  transform: perspective(100px) translateY(800px) translateZ(-20px);
      transition: 1s;
    transition-timing-function: cubic-bezier(0.64, 0.57, 0.67, 1.23);
    transition-delay: 3s;
}

.launched{

  h2{
    .s,.m,.l{
      transform: translate(0);
    }
  }

  .furgon-banner{
    transform: translate(0) translateZ(0);
  }

  .btn.-action{
    transform: perspective(100px) translateY(0px) translateZ(0px);
  }

}

@media screen and (max-width: 650px){
  .banner-historia{
    padding: 100px 20px;
    min-height: 0;
  }

  h2{
    .s{
      font-size: 30px;
    }
    .m{
      font-size: 50px;
      transform: translateX(200%);
    }
    .l{
      font-size: 70px;
    }
  }
}


@media screen and (max-width: 400px){

  .banner-historia{
    padding: 50px 0;
  }

  h2{
    .s{
      font-size: 20px;
    }
    .m{
      font-size: 30px;
    }
    .l{
      font-size: 50px;
    }
  }


}


</style>



// WEBPACK FOOTER //
// src/components/view-parts/historia/banner-historia.vue